import * as _usr_const from '../../../config/usr-constant';
import * as _debug from '../../../helper/debug';
import axios from 'axios';

type getStatusesProps = {
  unmounted: boolean,
  setStatuses: React.Dispatch<React.SetStateAction<{}>>,
  setStatusesError: React.Dispatch<React.SetStateAction<boolean>>,
  source: any
}
export async function getStatuses({
  unmounted,
  setStatuses,
  setStatusesError,
  source
}: getStatusesProps) {
  // get data
  await axios
  .get(
    _usr_const.ApiUrl + 'customer-statuses/get-customer-statuses/index.json', {
      cancelToken: source.current.token
    }
  )
  .then((response) => {    
    if (typeof response.data !== 'undefined') {
        let statuses: any = {};
        for (const customerStatus of response.data.customer_statuses) {
          statuses[customerStatus['id']] = customerStatus['name'];
        }
        if (!unmounted) {
          setStatuses(statuses);
        }
    }
  })
  .catch((error) => {
    _debug.debugAxiosError(error);
    if (!unmounted) { 
      setStatusesError(true);
    }
  })
  .finally(() => {
    return Promise.resolve(1);
  });
}